/* eslint-disable import/prefer-default-export */
import { browserHistory } from 'react-router';
import { createWeddingForRegistryAccountUser, createWeddingForExistingUser } from '../../../actions/WeddingActions';
import { showModal } from '../../../actions/ModalActions';
import { trackOnboardingStarted, trackOnboardingCompleted } from '../../../util/trackingHelper';

export function callToAction(businessUnitFeature) {
  return (dispatch, getState) => {
    const state = getState();
    const { userContext } = state.user;
    const goToManage = () => { browserHistory.push('/wedding/manage'); };
    const validateBusinessUnitFeature = () => {
      const validFeatures = ['WEDDING_WEBSITE', 'WEDDING_GUEST_LIST', 'WEDDING_CHECKLIST', 'WEDDING_PLANNING'];
      return validFeatures.indexOf(businessUnitFeature) > -1 ? businessUnitFeature : 'WEDDING_PLANNING';
    };
    const validBusinessUnitFeature = validateBusinessUnitFeature();
    const handleRedirect = () => {
      trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true);
      setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', true));
      switch (validBusinessUnitFeature) {
        case 'WEDDING_WEBSITE': browserHistory.push('/wedding/manage/website/designs'); break;
        case 'WEDDING_GUEST_LIST': browserHistory.push('/wedding/manage/guests/all'); break;
        case 'WEDDING_CHECKLIST': browserHistory.push('/wedding/manage/checklist'); break;
        default: goToManage();
      }
    };
    if (userContext.has_wedding_account) {
      return goToManage();
    } else if (userContext.has_registry) {
      return dispatch(createWeddingForRegistryAccountUser())
      .then(() => handleRedirect());
    } else if (userContext.has_completed_onboarding) {
      return dispatch(createWeddingForExistingUser())
        .then(() => {
          setTimeout(trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true));
          setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', true));
          if (validBusinessUnitFeature === 'WEDDING_WEBSITE') {
            browserHistory.push('/wedding/manage/website/designs');
          } else {
            goToManage();
          }
        });
    } else if (!userContext.is_guest) {
      setTimeout(trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true));
      browserHistory.push(`/wedding/onboard?product=${validBusinessUnitFeature}`);
    } else if (userContext.is_guest) {
      if (window.zolaNav && window.zolaNav.openSignupModal) {
        window.zolaNav.businessUnitFeature = validBusinessUnitFeature;
        window.zolaNav.businessUnitComponent = 'WEDDINGS';
        window.zolaNav.openSignupModal();
      } else {
        return dispatch(showModal('AUTH', { authState: 'signup', autoCreate: true }, { size: 'md' }));
        // TODO: Additional logic for tracking and buisness unit attribution handled in web-nav should be added here.
      }
    }
    return undefined;
  };
}



// WEBPACK FOOTER //
// ./src/pages/preauth/util/LandingPageCtaHelper.js